import React from 'react';
import styled, { css } from 'styled-components';
import { lightGrey1Color, lightGrey3Color } from 'js/config/style';
import chroma from 'chroma-js';

const firstCol = '105px';

const hasErrorStyle = css`
  background: ${({ errorColor }) => errorColor || '#ffeeee'};
  border-top: 1px solid ${({ errorColor }) => chroma(errorColor || '#ffeeee').darken(0.25)};
`;

const Row = styled(({ hasError, errorColor, ...rest }) => <div {...rest} />)`
  display: grid;
  grid-template-columns: ${({ cols }) =>
    cols === 1 ? '1fr' : cols === 2 ? `${firstCol} 1fr` : `${firstCol} 1fr 2.5rem`};
  border-top: 1px solid ${lightGrey1Color};
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'auto')};
  padding-right: ${({ cols }) => (cols < 3 ? '1rem' : 0)};
  ${({ hasError }) => hasError && hasErrorStyle}

  &:hover .pencil {
    fill: ${lightGrey3Color.darken()};
  }

  &:active .pencil {
    fill: black;
  }
`;

export default ({ children, ...rest }) => (
  <Row cols={React.Children.count(children)} {...rest}>
    {children}
  </Row>
);
